
//64
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "mixins2080493854",
    {"ellipsisMixin":"mixins2080493854--ellipsisMixin","root":"mixins2080493854--root"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/mixins/mixins.st.css
// module id = 1292
// module chunks = 0